<mat-slide-toggle
    [checked]="checked"
    [disabled]="disabled"
    class="aum-switch"
    (change)="onToggleChange($event)"
></mat-slide-toggle>
